import React from 'react';

export const ConditionalWrapper = ( { condition, children, elseContent } ) => {
  return condition ? <>{ children }</> : <>{ elseContent }</>;
}

export default ConditionalWrapper;
